import { useRouter } from 'vue-router'

import { closeDialog } from '@/shared/dialogs/dialog'

export function useFromInvite(email: string) {
  const router = useRouter()

  const handleCreateAccountClick = () => {
    router.push(`/register?email=${email}`)
    closeDialog()
  }

  const handleSignInClick = () => {
    router.push('/login')
    closeDialog()
  }

  return { handleCreateAccountClick, handleSignInClick }
}
